document.addEventListener("DOMContentLoaded", () => {
  // WhatsApp
  const whatsappBtn = document.getElementById("chwhatsapp-btn");
  if (whatsappBtn) {
    whatsappBtn.addEventListener("click", () => {
      gtag("event", "click_whatsapp", {
        send_to: "G-4TSRXYCZ1P"
      });
    });
  }

  // Tel links
  document.querySelectorAll('a[href^="tel:"]').forEach(link => {
    link.addEventListener("click", () => {
      gtag("event", "click_tel", {
        send_to: "G-4TSRXYCZ1P"
      });
    });
  });

  // Mailto links
  document.querySelectorAll('a[href^="mailto:"]').forEach(link => {
    link.addEventListener("click", () => {
      gtag("event", "click_mail", {
        send_to: "G-4TSRXYCZ1P"
      });
    });
  });

  // Hero Grid - Showroom block
  document.querySelectorAll('[data-hero-showroom]').forEach(link => {
    link.addEventListener("click", () => {
      gtag("event", "click_hero_showroom", {
        send_to: "G-4TSRXYCZ1P"
      });
    });
  });

  // Hero Grid - Product blocks
  document.querySelectorAll('[data-hero-product]').forEach(link => {
    link.addEventListener("click", () => {
      const productTitle = link.getAttribute('data-product-title');
      gtag("event", "click_hero_product", {
        send_to: "G-4TSRXYCZ1P",
        product_name: productTitle
      });
    });
  });
});
